{
  const BaseModule = require('_base/base')

  const CLASS_STICKY = 'is__sticky'

  const round = x => Math.ceil(x * 2).toFixed() / 2

  class BleedImage extends BaseModule {
    preInit() {
      this.CLASS_BLEED = 'is__bleed'

      this.OPPOSITES = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left',
      }

      this.compensateSide = this.compensateSide.bind(this)
    }

    postInit() {
      this.$page = this.$el.closest('.js__page')

      this.isSticky = this.$page.hasClass(CLASS_STICKY)
      this.initialMargin = this.$el.css('margin')
      this.imageRatio = this.$el.data('width') / this.$el.data('height')
      this.elStyle = getComputedStyle(this.$el[0])
      this.initialWidth = this.elStyle.getPropertyValue('width')
      this.initialHeight = this.elStyle.getPropertyValue('height')
      this.widthCompensator = 0
      this.heightCompensator = 0

      this.initBleeds()
    }

    get isMobile() {
      return window.application.isOnMobileScreen && window.application.hasMobileVersion
    }

    get parentPage() {
      return this.$page[0]
    }

    get parentPageWidth() {
      return this.parentPage.getBoundingClientRect().width
    }

    get parentPageLeftOffset() {
      return this.parentPage.getBoundingClientRect().left
    }

    get bookViewWidth() {
      return this.spread._book.actualViewWidth
    }

    get hasFixedWidth() {
      return this.initialWidth !== 'auto'
    }

    postReset() {
      this.$el.css('margin', this.initialMargin)
      this.bleeds.forEach(bleed => this.$el.removeClass(bleed.className))
      this.widthCompensator = 0
      this.heightCompensator = 0

      if (this.hasFixedWidth) {
        this.$el.css({
          width: this.initialWidth,
          height: this.initialHeight,
        })
      }
    }

    postCalculate() {
      const offset = this.$el.offset()
      const elTopOffset = offset.top
      const elLeftOffset = offset.left

      const pageTopOffset = this.$page.offset().top
      const pageLeftOffset = this.isMobile ? this.parentPageLeftOffset : 0
      const pageHeight = this.$page.outerHeight()

      this.calculateOpticalMargins()

      this.height = this.$el.height()
      this.width = this.$el.width()

      const viewWidth = this.isMobile ? this.parentPageWidth : this.bookViewWidth

      this.distances = {}
      this.distances.top = round(elTopOffset - pageTopOffset)
      this.distances.left = round(elLeftOffset - pageLeftOffset)
      this.distances.bottom = round(pageHeight - this.distances.top - this.height)
      this.distances.right = round(viewWidth - this.distances.left - this.width)

      this.compensateDistances()

      this.calculatedWidth = this.height * this.imageRatio
      this.calculatedHeight = this.width / this.imageRatio
    }

    calculateOpticalMargins() {
      this.opticalMargins = {
        top: parseFloat(this.elStyle.getPropertyValue('margin-top')),
        right: parseFloat(this.elStyle.getPropertyValue('margin-right')),
        bottom: parseFloat(this.elStyle.getPropertyValue('margin-bottom')),
        left: parseFloat(this.elStyle.getPropertyValue('margin-left')),
      }
    }

    compensateDistances() {
      ['top', 'right', 'bottom', 'left'].forEach(this.compensateSide)
    }

    compensateSide(side) {
      this.distances[side] -= this.opticalMargins[side]
    }

    preRender() {
      this.bleeds.forEach(bleed => {
        if (bleed.hasOpposite || this.testBleed(bleed.direction)) {
          this.$el.css('margin-' + bleed.direction, -this.distances[bleed.direction])
          this.$el.addClass(bleed.className)

          this.collectCompensators(bleed.direction)
        }
      })

      if (this.hasFixedWidth) this.correctDimensions()
    }

    constructBleedClass(bleed) {
      return this.CLASS_BLEED + bleed.charAt(0).toUpperCase() + bleed.slice(1)
    }

    initBleeds() {
      this.directions = this.$el.data('bleed').split(/[ ,]/)
        .filter(direction => direction.length)

      this.bleeds = this.directions.map(direction => ({
        direction: direction,
        className: this.constructBleedClass(direction),
        hasOpposite: this.directions.indexOf(this.OPPOSITES[direction]) > -1,
      }))
    }

    testBleed(bleed) {
      if (bleed === 'left' || bleed === 'right') {
        if (this.directions.indexOf('top') > -1 || this.directions.indexOf('bottom') > -1) {
          return true
        }

        return this.calculatedWidth > this.width
      }

      if (this.directions.indexOf('left') > -1 || this.directions.indexOf('right') > -1) {
        return true
      }

      return this.calculatedHeight > this.height
    }

    collectCompensators(direction) {
      if (direction === 'left' || direction === 'right') {
        this.widthCompensator += this.distances[direction]
      } else {
        this.heightCompensator += this.distances[direction]
      }
    }

    correctDimensions() {
      this.$el.css({
        width: (this.calculatedWidth + this.widthCompensator),
        height: (this.calculatedHeight + this.heightCompensator),
      })

      this.resizeSpreadOnMobile()
    }

    resizeSpreadOnMobile() {
      if (this.isMobile) this.spread.resize()
    }
  }

  $('.js__bleed').each(function() {
    new BleedImage($(this))
  })
}
